import Teacher from "./teacher/facial_teacher.store";
import Staff from "./staff/facial_staff.store";

export default {
  modules: {
    Teacher,
    Staff,
  },
};
